module.exports = __webpack_public_path__ + "static/media/extra_words_not_available_ic.4d92bdd9.svg";